import { useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import Paginate from "@/components/lib/paginat";
import useAuth from "@/hooks/useAuth";
import OnlyTableSekeleton from "@/components/skeleton/only-table-skeleton";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { TakeAwayItemTable } from "@/components/backoffice/cost-management/take-away-item-table";
import { formatCurrency } from "@/lib/utils";
import { fetchReplaceItemReport } from "@/redux/slice/cost-management/cost-management-slice";
import useDebounce from "@/hooks/useDebounce";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";

function TableReplaceItemReport() {
  const { user } = useAuth();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [orderId, setOrderId] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const dibounch = useDebounce(searchTerm);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { orders, getLoading, statistics, pagination } = useSelector(
    (state) => state.costManagement,
  );

  const buildSearchTerm = () => {
    const terms = [];
    if (phoneNumber) terms.push(phoneNumber);
    if (orderId) terms.push(orderId);
    return terms.join(" ");
  };

  useEffect(() => {
    const formattedStartDate = startDate ? format(startDate, "yyyy-MM-dd") : "";
    const formattedEndDate = endDate ? format(endDate, "yyyy-MM-dd") : "";
    const combinedSearchTerm = buildSearchTerm();

    dispatch(
      fetchReplaceItemReport({
        restaurant_id: user?.restaurant_id,
        params: {
          per_page: perPage,
          page: currentPage,
          report_type: "takeaway",
          start_date: formattedStartDate,
          end_date: formattedEndDate,
          order_id: orderId,
        },
      }),
    );
  }, [
    perPage,
    phoneNumber,
    orderId,
    currentPage,
    dibounch,
    dispatch,
    user?.restaurant_id,
    startDate,
    endDate,
  ]);

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
      pageName={{ title: "Overview" }}
      paths={[
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Cost Management", path: "" },
        {
          name: "Take-away Replace Item Report",
          path: "/backoffice/cost-management/take-away-replace-item-report",
        },
      ]}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <div className="flex justify-between w-full gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2  items-center gap-4 w-full">
            <div className="">
              <div
                className={`bg-cblack3 shadow-md rounded-lg p-4 flex flex-col gap-2 relative`}
              >
                <div>
                  <h2 className="text-sm text-color5">Total Amount</h2>
                </div>
                <div className=" w-full flex items-center ">
                  <div>
                    <h3 className="text-lg font-semibold text-color5">
                      {formatCurrency(statistics?.total_amount || 0)}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <div
                className={`bg-cblack3 shadow-md rounded-lg p-4 flex flex-col gap-2 relative`}
              >
                <div>
                  <h2 className="text-sm text-color5">Total Amount</h2>
                </div>
                <div className=" w-full flex items-center ">
                  <div>
                    <h3 className="text-lg font-semibold text-color5">
                      {formatCurrency(statistics?.this_month || 0)}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full ">
            <div className="flex flex-col gap-1.5 justify-end items-end">
              <div className="flex gap-3 justify-center items-center">
                <Popover className="">
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      className="w-full justify-start text-left font-normal border-gray-600 text-cwhite"
                    >
                      {startDate ? format(startDate, "PPP") : "Start Date"}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                      mode="single"
                      selected={startDate}
                      onSelect={setStartDate}
                      initialFocus
                    />
                  </PopoverContent>
                </Popover>

                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      className="w-full justify-start text-left font-normal border-gray-600 text-cwhite"
                    >
                      {endDate ? format(endDate, "PPP") : "End Date"}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                      mode="single"
                      selected={endDate}
                      onSelect={setEndDate}
                      initialFocus
                    />
                  </PopoverContent>
                </Popover>
              </div>
            </div>
          </div>
        </div>
        <Card className="bg-cblack3 border-0">
          <CardContent className="flex justify-between flex-col gap-5 items-center mt-4">
            <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
              <div className="flex justify-between items-center gap-3 flex-wrap">
                {/* <div className="grid max-w-sm items-center gap-1.5">
                  <Label className="text-base text-white" htmlFor="">
                    Reservation Id
                  </Label>
                  <Input
                    className="text-gray-300"
                    type="text"
                    id=""
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="Search by reservation Id"
                  />
                </div> */}
                <div className="grid max-w-sm items-center gap-1.5">
                  <Label className="text-base text-white" htmlFor="">
                    Order ID
                  </Label>
                  <Input
                    className="text-gray-300"
                    type="text"
                    id=""
                    value={orderId}
                    onChange={(e) => setOrderId(e.target.value)}
                    placeholder="Search by Order ID"
                  />
                </div>
              </div>
              <div className="flex items-center gap-5">
                <div>
                  <Button variant="ghost" className="bg-cblack7 text-cwhite">
                    Export
                  </Button>
                </div>
                <div className="flex gap-1 justify-center items-center">
                  <h3 className="text-white">Show</h3>
                  <Select
                    onValueChange={(value) => setPerPage(Number(value))}
                    value={perPage.toString()}
                  >
                    <SelectTrigger className="w-[60px]">
                      <SelectValue placeholder="10" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectItem value="10">10</SelectItem>
                        <SelectItem value="20">20</SelectItem>
                        <SelectItem value="40">40</SelectItem>
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
              </div>
            </div>
            <div className="w-full">
              {getLoading ? (
                <OnlyTableSekeleton row={4} header={false} />
              ) : (
                <TakeAwayItemTable data={orders} />
              )}
            </div>
            <Paginate
              pagination={pagination}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </CardContent>
        </Card>
      </div>
    </Layout2>
  );
}

export default TableReplaceItemReport;
